module.exports = __webpack_public_path__ + "img/add.28f381b2.svg";